export default {
     //Estatus de los solicitudes de cotizacion
     quote_statuses_list: {
        in_quotation: "En Cotizacion",
        quotation_ready: "Cotizacion Lista",
        in_review: "En Revision",
        pending_validation: "Pendiente de Validacion",
        user_validation: "Pendiente de Validacion por Usuario",
        user_validation_variant: "Pendiente de Revision por Usuario",
        pending_user: "Pendiente de Usuario",
        approved: "Aprobada",
        rejected: "Rechazada",
        rejected_variant: "Rechazado",
        finished: "Finalizada",
        canceled: "Cancelada",
    },

    // Categorias de documentos
    document_category_quotes: 0,
    document_category_maverick_purchase: 1,
    document_category_other: 2,
    
    // Categorias de Texto de documentos
    document_category_quotes_text: "Cotizacion",
    document_category_maverick_purchase_text: "Maverick",
    document_category_other_text: "Otros",
    
    //METODOS
    // Obtener las cotizaciones posterior a la creacion de la solicitud
    getQuoteStatusesList: function(){
      return [
        this.quote_statuses_list.in_quotation,
        this.quote_statuses_list.user_validation_variant,
        this.quote_statuses_list.rejected_variant,
        this.quote_statuses_list.finished,
      ]
    },
    //Obtener el tipo de documento de una solicitud de cotizacion
    getTypeDocumentFromFile(document){
      switch(document.category){
        case this.document_category_quotes:
          return 'Cotizacion'
        default:
          return 'Otros'
      }
    },
    //Obtener los documentos de una solicitud de cotizacion
    getRequestQuotesPost: function(request){
       return request.documents.filter(document => document.document_type == this.document_category_quotes_text)
    },
    //Obtener Corrección de nombre de estatus
    getStatusCorrection: function(status, approved) 
    {
        if(approved && status == this.quote_statuses_list.user_validation_variant){
          return this.quote_statuses_list.user_validation.replace("Validacion", "Validación")
        }
        return status
          .replace("Cotizacion", "Cotización")
          .replace("Aprobacion", "Aprobación")
          .replace("Revision", "Revisión")
          .replace("Validacion", "Validación");
    },
    //Obtener el color de la etapa de un servicio
     getStatusColor: function(status, approved){
        if(approved && status == this.quote_statuses_list.user_validation_variant){
          return 'teal darken-2'
        }
        switch(status){
          case this.quote_statuses_list.in_quotation:
            return 'warning'
          case this.quote_statuses_list.in_review:
            return 'cyan'  
          case this.quote_statuses_list.quotation_ready:
            return 'success'
          case this.quote_statuses_list.pending_validation:
            return 'info'
          case this.quote_statuses_list.purchase_validation_variant:
            return 'deep-orange darken-2'
          case this.quote_statuses_list.quotation_in_validation:
            return 'grey'
          case this.quote_statuses_list.user_validation_variant:
            return 'brown darken-2'
          case this.quote_statuses_list.finished:
            return 'purple'
          case this.quote_statuses_list.rejected:
            return 'red darken-2'
          case this.quote_statuses_list.rejected_variant:
            return 'red darken-2'
          default:
            return 'primary'
        }
      },
    // Validar que el servicio tenga al menos una cotización (Para compras)
    ifServiceHasQuotedFromTeamPurchase: function (service){
      return service.documents.find(
        document => document.document_type == this.document_category_quotes_text &&
        document.created_by !== service.created_by
      );
    },
     // Validar que todas las cotizaciones tengan un precio y proveedor definido (Para compras)
     ifServiceHasQuotedWithNoPriceOrSupplierFromTeamPurchase: function (service){
      return service.documents.find(
        document => document.document_type == this.document_category_quotes_text &&
        (!document.price || !document.supplier) &&
        document.created_by !== service.created_by
      );
    },
     // Validar si el servicio posee una cotización adjunta y no tiene precio o proveedor definido
     ifServiceHasQuotedWithNoPriceOrSupplier: function (service){
      return service.documents.find(document => document.document_type == this.document_category_quotes_text && (!document.price || (!document.supplier_rut && !document.supplier)));
    },
}